import React, {ReactNode} from 'react'

interface PrimaryButtonProps {
  className?: string
  id?: string
  title?: string
  type?: 'button' | 'submit' | 'reset'
  // onClick?: () => void
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void | Promise<void> | null
  children: ReactNode
  disabled?: boolean
  color?: string
}

const PrimaryButton: React.FC<PrimaryButtonProps> = ({
  className = '',
  id = '',
  type = 'button',
  onClick,
  title,
  children,
  disabled = false,
  color = 'primary',
}) => {
  return (
    <button
      className={`btn bg-${color} text-white d-flex align-items-center justify-content-center ${className}`}
      onClick={onClick}
      title={title}
      disabled={disabled}
      id={id}
      type={type}
    >
      {children}
    </button>
  )
}

export default PrimaryButton
